import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const lgSizeClassName =
  'h-[72px] w-[72px] bg-[var(--color-avatar-bg)] text-[36px] leading-[130%] text-[var(--color-on-surface)]';

export const EntityIconLg = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} sizeClassName={sizeClassName ?? lgSizeClassName} className={className} />
);
